// cloud app init types
export var ApplePayAuthMethod;

(function (ApplePayAuthMethod) {
  ApplePayAuthMethod["SUPPORTS_3DS"] = "supports3DS";
})(ApplePayAuthMethod || (ApplePayAuthMethod = {}));

export var ApplePayCardNetwork;

(function (ApplePayCardNetwork) {
  ApplePayCardNetwork["AMEX"] = "amex";
  ApplePayCardNetwork["DISCOVER"] = "discover";
  ApplePayCardNetwork["JCB"] = "jcb";
  ApplePayCardNetwork["MASTERCARD"] = "masterCard";
  ApplePayCardNetwork["VISA"] = "visa";
  ApplePayCardNetwork["INTERAC"] = "interac";
})(ApplePayCardNetwork || (ApplePayCardNetwork = {}));

export var PaymentMethods;

(function (PaymentMethods) {
  PaymentMethods["PAY_ONLINE"] = "PAY_ONLINE";
  PaymentMethods["PAY_REST"] = "PAY_REST";
  PaymentMethods["BOTH"] = "BOTH";
})(PaymentMethods || (PaymentMethods = {}));

export var APIHeaders;

(function (APIHeaders) {
  APIHeaders["X_Source_Channel"] = "X-Source-Channel";
  APIHeaders["X_Concept_Code"] = "X-Concept-Code";
  APIHeaders["Authorization"] = "Authorization";
})(APIHeaders || (APIHeaders = {}));

export var AuthAction;

(function (AuthAction) {
  AuthAction["CREATE_ACCOUNT"] = "create-account";
  AuthAction["LOGOUT"] = "logout";
  AuthAction["LOGIN"] = "login";
})(AuthAction || (AuthAction = {}));

export var TOGO_DELIVERY_FLOW_ERRORS;

(function (TOGO_DELIVERY_FLOW_ERRORS) {
  TOGO_DELIVERY_FLOW_ERRORS["CREATEQUOTE"] = "CREATEQUOTE-";
  TOGO_DELIVERY_FLOW_ERRORS["CREATEDELIVERY"] = "CREATEDELIVERY-";
  TOGO_DELIVERY_FLOW_ERRORS["USED_QUOTE"] = "used_quote";
  TOGO_DELIVERY_FLOW_ERRORS["DRI_100"] = "DRI-100";
  TOGO_DELIVERY_FLOW_ERRORS["DRI_102"] = "DRI-102";
  TOGO_DELIVERY_FLOW_ERRORS["DRI_103"] = "DRI-103";
  TOGO_DELIVERY_FLOW_ERRORS["DRI_570"] = "DRI-570";
  TOGO_DELIVERY_FLOW_ERRORS["CHECK_NOT_FOUND_BY_ORDER_ID"] = "CheckServiceCheckNotFoundByOrderID";
  TOGO_DELIVERY_FLOW_ERRORS["CRT_448"] = "CRT448";
  TOGO_DELIVERY_FLOW_ERRORS["UPDATE_DELIVERY_ERROR_NO_RETRY"] = "UPDATEDELIVERYERROR-NO-RETRY";
  TOGO_DELIVERY_FLOW_ERRORS["CRT_426"] = "CRT426";
})(TOGO_DELIVERY_FLOW_ERRORS || (TOGO_DELIVERY_FLOW_ERRORS = {}));

export var TOGO_DELIVERY_FLOW_PAYMENT_ERRORS;

(function (TOGO_DELIVERY_FLOW_PAYMENT_ERRORS) {
  TOGO_DELIVERY_FLOW_PAYMENT_ERRORS["CCPayAuthFail"] = "OrderService-CCPayAuth-Fail";
  TOGO_DELIVERY_FLOW_PAYMENT_ERRORS["GCPayAuthFail"] = "OrderService-GCPayAuth-Fail";
  TOGO_DELIVERY_FLOW_PAYMENT_ERRORS["PaymentIncomplete"] = "OrderService-Paymt-Incomplete";
  TOGO_DELIVERY_FLOW_PAYMENT_ERRORS["PaymentUnpaid"] = "OrderService-Paymt-Unpaid";
})(TOGO_DELIVERY_FLOW_PAYMENT_ERRORS || (TOGO_DELIVERY_FLOW_PAYMENT_ERRORS = {}));

export var TOGO_DELIVERY_FLOW_ERROR_MESSAGES;

(function (TOGO_DELIVERY_FLOW_ERROR_MESSAGES) {
  TOGO_DELIVERY_FLOW_ERROR_MESSAGES["USED_QUOTE"] = "Your quote might have expired, please try again.";
})(TOGO_DELIVERY_FLOW_ERROR_MESSAGES || (TOGO_DELIVERY_FLOW_ERROR_MESSAGES = {}));